import { Dispatch, SetStateAction } from 'react';
import { useAuth } from 'hooks/useAuth';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Spinner } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { StyledDeleteModal } from './style';

interface DeleteModalProps {
  setRefresh?: Dispatch<SetStateAction<number>>;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
  url?: string;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  showModal: boolean;
  deleteId?: number;
  confirmText?: string;
  manualOnModalOk?: Function;
  params?: ParamProps;
  userRefetch?: boolean;
  method?: 'DELETE' | 'POST';
}

interface ParamProps {
  [key: string]:
    | string[]
    | string
    | number[]
    | number
    | boolean[]
    | boolean
    | React.Key[];
}

export const DeleteModal = ({
  setRefresh,
  setIsLoading,
  url,
  setShowModal,
  showModal,
  deleteId,
  confirmText,
  manualOnModalOk,
  params,
  userRefetch = false,
  method = 'DELETE',
}: DeleteModalProps) => {
  const intl = useIntl();
  const { refetchUser } = useAuth();

  const { appendData, isLoading } = useQueryApiClient({
    request: {
      url: url?.replace('{id}', deleteId?.toString() || '') || '',
      method: method,
    },
    onSuccess: () => {
      setRefresh && setRefresh((old: number) => old + 1);
      setIsLoading && setIsLoading(false);
      userRefetch && refetchUser();
    },
  });

  const onModalOk = () => {
    appendData(params || []);
    setShowModal(false);
  };

  return (
    <StyledDeleteModal
      onCancel={() => setShowModal(!showModal)}
      open={showModal}
      closable={false}
      footer={
        <>
          <Button
            label={intl.formatMessage({
              id: 'general.no',
            })}
            onClick={() => setShowModal(false)}
          />
          <Button
            label={intl.formatMessage({
              id: 'general.yes',
            })}
            onClick={manualOnModalOk || onModalOk}
          />
        </>
      }
    >
      <Spinner spinning={isLoading}>
        <h3 className={'confirm-title'}>
          <ExclamationCircleOutlined />
          {confirmText ? (
            <FormattedMessage id={confirmText} />
          ) : (
            <FormattedMessage id={'message.are_you_shure_to_delete'} />
          )}
        </h3>
      </Spinner>
    </StyledDeleteModal>
  );
};
